import Vue from 'vue'
import {
  SET_FILTER_VARIANTS,
} from './mutation-types';


export default {
  namespaced: true,
  state: {
    filterByVariants: [
      {
        id: 1,
        name: 'all',
        checked: false,
      },
      {
        id: 2,
        name: 'passport',
        checked: false,
      },
      {
        id: 3,
        name: 'insurance',
        checked: false,
      },
      {
        id: 7,
        name: 'visa',
        checked: false,
      },
      {
        id: 5,
        name: 'invite',
        checked: false,
      },
      {
        id: 4,
        name: 'tickets',
        checked: false,
      },
      {
        id: 6,
        name: 'documents',
        checked: false,
      },
    ],
  },
  mutations: {
    [SET_FILTER_VARIANTS]: (state, payload) => {
      const {checked, id} = payload;

      if (id === 1) {
        state.filterByVariants.forEach(el => {
          Vue.set(el, 'checked', false)
        })

        Vue.set(state.filterByVariants[0], 'checked', true)
      } else {
        Vue.set(state.filterByVariants[0], 'checked', false)

        const index = state.filterByVariants.findIndex(el => el.id === id)
        Vue.set(state.filterByVariants[index], 'checked', checked)
      }
    },
  },
  getters: {
    filterBy(state) {
      return state.filterByVariants.reduce((result, el) => {
        if (el.checked) {
          result.push(el.name)
        }

        return result
      }, [])
    }
  },
  actions: {},
};
